<script>
  export let 
    fill = "white",
    height = "70px",
    points = "0,0 100,100 0,100";
</script>
<style>
  .divider {
    width: 100%;
    background-image: inherit;
    max-height: 100px;
  }
</style>

<svg
  style="fill:{fill};height:{height}"
  class="divider"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 100 100"
  preserveAspectRatio="none">
  <polygon points={points} />
</svg>
